import { Controller } from "stimulus"

export default class extends Controller {

  toggler() {
    const toggleCSSclasses = (el, ...cls) => cls.map(cl => el.classList.toggle(cl));
    const el = document.getElementById('toggler');
    const before = document.getElementById('before');
    const after = document.getElementById('after');
    const btn = document.getElementById('buttonToggler');
    const checkbox = document.getElementById('planValue');

    // Toggle classes on toggler
    toggleCSSclasses(el, '-translate-x-8', '-translate-x-2');
    toggleCSSclasses(before, 'text-white');
    toggleCSSclasses(after, 'text-white');

    // Replace 1 year with 5 year and viza versa
    el.innerHTML.replace(/\s/g, "") === "1år" ? el.innerHTML = "5 år" : el.innerHTML = "1 år";

    // Set value to 5 or 1 depending on the toggler
    btn.value == 5 ? btn.value = "1" : btn.value = "5";

    // Check plan checkbox when pressing button
    checkbox.click();
  }
}
